import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const SidebarQuoteAiViewPage = ({ refs }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [checkedItem, setCheckedItem] = useState('InsuredInformation');

  const handleCheckboxChange = (section) => {
    setCheckedItem(section.name);
    navigate(section.path);
  };

  const scrollToSection = (id) => {
    setCheckedItem(id);

    if (refs[id]?.current) {
      refs[id].current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });

      setTimeout(() => {
        const offset = -50;
        const elementPosition =
          refs[id].current.getBoundingClientRect().top + window.pageYOffset + offset;
        window.scrollTo({
          top: elementPosition,
          behavior: 'smooth',
        });
      }, 300);
    }
  };

  return (
    <div id="viewsidebarquoteAi">
      <div className="sidebar-pinned">
        <div className="sidebar-view-container">
          {Object.keys(refs).map((key, index) => {
            const section = refs[key];
            const isChecked = checkedItem === key;

            // Convert camelCase or PascalCase to words with spaces
            const formattedName = key.replace(/([a-z])([A-Z])/g, '$1 $2');

            return (
              <div
                key={index}
                className={`sidebar-item ${isChecked ? 'checked' : ''}`}
                onClick={() => scrollToSection(key)}
              >
                <div style={{ color: isChecked ? '#fff' : '#344054' }}>{section.icon}</div>
                <span
                  style={{
                    color: isChecked ? '#fff' : '#344054',
                    fontWeight: '400',
                    letterSpacing: '0.2px',
                  }}
                >
                  {formattedName}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SidebarQuoteAiViewPage;
